import React from "react";
import { CircularProgress } from "@material-ui/core";

export default () => (
  <div className="spinner" style={{ display: "flex", alignItems: "center" }}>
    <CircularProgress />
  </div>
);
